import { render, staticRenderFns } from "./GdprSettings.vue?vue&type=template&id=2397745b&"
import script from "./GdprSettings.vue?vue&type=script&lang=js&"
export * from "./GdprSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GdprSettings.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
installComponents(component, {
  VAlert,
  VCard,
  VCardText,
  VCardTitle,
  VCheckbox,
})
